<script setup lang="ts">
const productLinks = [
  { href: "#besturen", label: "Voor besturen" },
  { href: "#functies", label: "Functies" },
  { href: "#hoe-het-werkt", label: "Zo werkt het" },
];

const legalLinks = [
  { href: "/algemene-voorwaarden", label: "Algemene voorwaarden" },
  { href: "/privacybeleid", label: "Privacybeleid" },
];

const year = new Date().getFullYear();
</script>

<template>
  <footer class="footer">
    <VContainer class="landing-container">
      <div class="footer__top">
        <div class="footer__brand">
          <img
            src="/branding/klupz-logo.svg"
            alt="Klupz"
            class="footer__logo"
          />
          <p>
            Vrijwilligerstaken regelen voor sportclubs - van aanmelding tot
            overzicht per seizoen.
          </p>
        </div>

        <div class="footer__links">
          <div>
            <h4>Product</h4>
            <a
              v-for="link in productLinks"
              :key="link.href"
              :href="link.href"
              >{{ link.label }}</a
            >
          </div>
          <div>
            <h4>Juridisch</h4>
            <a v-for="link in legalLinks" :key="link.href" :href="link.href">{{
              link.label
            }}</a>
          </div>
          <div>
            <h4>Contact</h4>
            <a href="mailto:info@bytechnology.nl">info@bytechnology.nl</a>
            <a href="tel:0762045123">076 - 204 51 23</a>
          </div>
        </div>
      </div>

      <div class="footer__bottom">
        <span>© {{ year }} Klupz</span>
        <span class="footer__built">
          Gebouwd door
          <img src="/branding/bytechnology-logo.svg" alt="Bytechnology" />
        </span>
      </div>
    </VContainer>
  </footer>
</template>

<style scoped lang="scss">
.footer {
  padding: 40px 0 32px;
}

.footer__top {
  display: flex;
  justify-content: space-between;
  gap: 32px;
  flex-wrap: wrap;
  padding-bottom: 24px;
  border-bottom: 1px solid rgb(var(--v-theme-border));
}

.footer__brand {
  max-width: 34ch;

  p {
    font-size: 13.5px;
    color: rgb(var(--v-theme-emphasis));
  }
}

.footer__logo {
  height: 24px;
  margin-bottom: 12px;
}

.footer__links {
  display: flex;
  gap: 48px;
  flex-wrap: wrap;

  h4 {
    font-size: 12.5px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: rgb(var(--v-theme-emphasis));
    margin: 0 0 10px;
  }

  a {
    display: block;
    font-size: 14px;
    padding: 4px 0;
  }
}

.footer__bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding-top: 20px;
  font-size: 12.5px;
  color: rgb(var(--v-theme-emphasis));
}

.footer__built {
  display: flex;
  align-items: center;
  gap: 8px;

  img {
    height: 14px;
    opacity: 0.8;
    position: relative;
    top: 2px;
  }
}
</style>
